/**
 * feature-config flag names owned by core-infrastructure
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const CORE_INFRASTRUCTURE_FLAG_NAMES = {
  CLOUDFLARE_MIGRATION: 'ff-core-1983-cloudflare-migration',
  BLOCK_PUBLISHING_PROXY_SSL_DNS: 'ff-core-2419-block-publishing-proxy-ssl-dns',
  EARLY_HINTS: 'ff-core-2745-early-hints',
  HOST_914_EU_S3_URL_REGIONALIZATION: 'ff-host-914-eu-s3-url-regionalization',
  HOST_919_EU_ASSISTANT_IMAGE_ALLOWLIST:
    'ff-host-919-eu-assistant-image-allowlist',
};
